import { useEffect, useState } from "react";
import { toast } from "sonner";
import { RefreshCw, CalendarClock } from "lucide-react";
import { api, errorMessage } from "@/lib/adminApi";

export default function GoogleSync({ onSynced }) {
    const [status, setStatus] = useState(null);
    const [busy, setBusy] = useState(false);

    const load = () => api.get("/admin/testimonials/sync").then((r) => setStatus(r.data)).catch(() => {});
    useEffect(() => {
        load();
    }, []);

    const syncNow = async () => {
        setBusy(true);
        try {
            const { data } = await api.post("/admin/testimonials/sync");
            if (data.error) toast.error(data.error);
            else toast.success(`Google sync: ${data.imported} new review${data.imported === 1 ? "" : "s"} added to pending`);
            load();
            if (data.imported > 0) onSynced();
        } catch (e) {
            toast.error(errorMessage(e));
        } finally {
            setBusy(false);
        }
    };

    const last = status?.last;
    return (
        <div className="rounded-2xl border border-border bg-surface p-6 lg:col-span-2" data-testid="google-sync-card">
            <div className="flex flex-wrap items-start justify-between gap-4">
                <div>
                    <h2 className="font-display text-lg font-bold">Automatic Google sync</h2>
                    <p className="mt-1 flex items-center gap-1.5 text-xs text-muted-foreground">
                        <CalendarClock size={13} /> Runs every Monday and Thursday at 8:00am Sydney. New reviews land in Pending and you get an email reminder.
                    </p>
                    <p className="mt-3 font-mono text-xs" data-testid="google-sync-status">
                        {status === null ? "Loading…" : status.configured
                            ? <span className="text-primary">Connected to Google Places</span>
                            : <span className="text-destructive">Not connected — add GOOGLE_PLACES_API_KEY and GOOGLE_PLACE_ID in the backend settings</span>}
                        {last && (
                            <span className="text-muted-foreground">
                                {" · "}last run {last.ran_at.slice(0, 16).replace("T", " ")} UTC ({last.trigger}) — {last.error ? last.error : `${last.imported} new of ${last.fetched} fetched`}
                            </span>
                        )}
                    </p>
                </div>
                <button
                    onClick={syncNow}
                    disabled={busy || !status?.configured}
                    data-testid="google-sync-now-btn"
                    className="inline-flex items-center gap-2 rounded-full border border-primary/40 px-5 py-2.5 text-sm font-semibold text-primary transition-colors duration-200 hover:bg-primary hover:text-primary-foreground disabled:cursor-not-allowed disabled:opacity-50"
                >
                    <RefreshCw size={14} className={busy ? "animate-spin" : ""} /> {busy ? "Syncing…" : "Sync now"}
                </button>
            </div>
        </div>
    );
}
